import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {AbstractDialogComponent} from '@wba-ui-module/components/dialogs/abstract-dialog.component';

@Component({
    selector: 'wba-loeschen-dialog',
    templateUrl: './loeschen-dialog.component.html',
    standalone: false
})
export class LoeschenDialogComponent extends AbstractDialogComponent {

  @Input() targetId: string;
  @Input() title: string;
  @Input() message: string;
  @Input() abbrechenBtnLabel = 'Abbrechen';
  @Input() loeschenBtnLabel = 'Ja, unwiderruflich löschen';
  @Input() modalType = 'modal';
  @Output() commitEvent = new EventEmitter();
  @Output() abortEvent = new EventEmitter();
  @Output() afterClosedEvent = new EventEmitter();

  payload;

  @ViewChild('modalRef') modalRef: ElementRef;
  @ViewChild('modalDialogEl') modalDialogEl: ElementRef;

  constructor() {
    super();
    this.options.backdrop = 'static';
    this.options.keyboard = false;
  }
  loeschenFn() {
    this.commitEvent.emit(this.payload);
    setTimeout(() => this.afterClosedEvent.emit());
  }

  abbrechenFn() {
    this.abortEvent.emit();
    setTimeout(() => this.afterClosedEvent.emit());
  }
}
